import request from '@/utils/request'

// 获取所有菜单
export function getAllMenu(params) {
    return request({
      url: '/account-bi/menu/getMenu',
      method: 'get',
      params: params
    })
  }


// 获取企业下拉框
export function getCompanyList(params) {
  return request({
    url: '/bi/common/getCompanyBox',
    method: 'get',
    params: params
  })
}

// 获取需求下拉框
export function getRequireList(params) {
  return request({
    url: '/bi/common/getRequireBox',
    method: 'get',
    params: params
  })
}
